(() => {
  if (window.collectionCardSecondaryImagesInitialized) return;
  window.collectionCardSecondaryImagesInitialized = true;

  const selector = '#ProductGridContainer img[data-card-secondary-image]';

  const loadImage = (image) => {
    if (!image || !image.matches(selector)) return;

    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.src) image.src = image.dataset.src;

    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
    image.removeAttribute('data-card-secondary-image');
    image.classList.remove('card-secondary-image-deferred');
  };

  const loadForTarget = (target) => {
    const card = target.closest('#ProductGridContainer .card-wrapper');
    if (!card) return;
    loadImage(card.querySelector('img[data-card-secondary-image]'));
  };

  document.addEventListener(
    'pointerover',
    (event) => {
      if (event.pointerType === 'touch') return;
      loadForTarget(event.target);
    },
    { passive: true }
  );

  document.addEventListener('focusin', (event) => loadForTarget(event.target));
})();
